import { render } from "./CoachItem.vue?vue&type=template&id=bfcc407e&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=bfcc407e&scoped=true&lang=css"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfcc407e"]])

export default __exports__